import React from "react";

import ResponsiveAppBar from "./ResponsiveAppBar";

const Header = () => {
  return <ResponsiveAppBar />;
};

export default Header;
